import { ReactComponent as EditIcon } from '../../../icons/edit.svg';

interface EditIconButtonProps {
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
}

const EditIconButton = ({ className = '', onClick, disabled = false }: EditIconButtonProps) => {
  return (
    <button
      type="button"
      className={`bg-textPrimary-light dark:bg-textPrimary-dark rounded-[20px] h-fit p-[2px] ${className} ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
    >
      <EditIcon className="fill-pure-white" width={'10px'} height={'10px'} />
    </button>
  );
};

export default EditIconButton;
